import React from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../components/page-components/blog/Hero";
import BlogsPanel from "../components/page-components/blog/BlogsPanel";

function Blog() {
  return (
    <>
      <Helmet>
        <title>
          Blog | Web Development, SEO, Digital Marketing & Cyber Security
          Insights
        </title>

        <meta
          name="description"
          content="Explore expert blogs on web development, SEO, digital marketing, cybersecurity, SaaS development, website optimization and business growth strategies by Web X Secure."
        />

        <meta
          name="keywords"
          content="Web Development Blog, SEO Blog, Digital Marketing Blog, Cyber Security Blog, SaaS Development, Website Optimization, Business Growth"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://webxsecure.in/blog" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Web X Secure Blog | Web Development, SEO & Digital Marketing Insights"
        />

        <meta
          property="og:description"
          content="Discover the latest insights on website development, SEO, digital marketing, cybersecurity, SaaS products and business growth."
        />

        <meta property="og:url" content="https://webxsecure.in/blog" />

        <meta property="og:image" content="https://webxsecure.in/logo.png" />

        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content="Web X Secure Blog" />

        <meta
          name="twitter:description"
          content="Explore web development, SEO, digital marketing and cybersecurity insights."
        />

        <meta name="twitter:image" content="https://webxsecure.in/logo.png" />

        {/* Collection Page Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "Web X Secure Blog",
            url: "https://webxsecure.in/blog",
            description:
              "Blogs covering web development, SEO, digital marketing, cybersecurity, SaaS development and business growth.",
          })}
        </script>

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://webxsecure.in",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Blog",
                item: "https://webxsecure.in/blog",
              },
            ],
          })}
        </script>
      </Helmet>

      <Hero />
      <BlogsPanel />
    </>
  );
}

export default Blog;
